import { createContext, useContext } from 'react';

import { MessageCapability } from '@/types/schema';

interface MessageCapabilitiesContextType {
  disabledCapabilities: MessageCapability[];
  isCapabilityDisabled: (capability: MessageCapability) => boolean;
}

export function useMessageCapabilities() {
  const context = useContext(MessageCapabilitiesContext);
  return context;
}
export const MessageCapabilitiesContext = createContext<
  MessageCapabilitiesContextType | undefined
>(undefined);
